import StaffMemberJobSection from './StaffMemberJobSection.container';

export default StaffMemberJobSection;
